import { useAppState } from 'store/Provider';
import { useSelector } from 'store/hooks';
import { clearSelectedFilterAction, resetFilterAction, selectFilterRemoveAction } from 'store/actions/filterActions';
import {
  changeSearchParamsAction,
  resetDeliverablesAction,
  selectDeliverablesAction,
} from 'store/actions/deliverableActions';
import { setActiveLastOrderIdAction, setActiveScrollOrderIdAction } from 'store/actions/managementActions';
import { todoCreateOrderScreen } from 'store/actions/dashboardActions';

/**
 * Custom hook to reset filters and deliverables
 * Useful when navigating away from deliverables, affectation, or changebaseline pages
 */
export const useResetFiltersAndDeliverables = () => {
  const { dispatch } = useAppState();
  const { filter, deliverable } = useSelector((state) => state);

  const resetFiltersAndDeliverables = () => {
    delete filter.selected?.mission_advancement_id;
    dispatch(resetDeliverablesAction());
    dispatch(selectFilterRemoveAction({ mission_advancement_id: [] }));
    dispatch(clearSelectedFilterAction());
    dispatch(resetFilterAction());
    dispatch(selectDeliverablesAction([]));
    delete deliverable.searchParams?.mission_advancement_id;
    delete deliverable.searchParams?.label;
    delete deliverable.searchParams?.rating;
    dispatch(changeSearchParamsAction(deliverable.searchParams));
    localStorage.removeItem('navigation_screen');
    localStorage.removeItem('from_source_page');
    dispatch(todoCreateOrderScreen(null));
    dispatch(setActiveScrollOrderIdAction(0));
    dispatch(setActiveLastOrderIdAction(null));
    localStorage.removeItem('forecast_date_mode');
    localStorage.removeItem('forecast_date_view');
  };

  return { resetFiltersAndDeliverables };
};
